type Paginable<T> = {
    fetchAll: (
        filter: Record<string, unknown>,
        token: string | undefined,
        limit: number,
        selectionSet: null,
        opts: { noCache: boolean }
    ) => Promise<{ items: T[]; nextToken?: string }>;
};

/**
 * Trae todos los registros de un modelo del tenant.
 *
 * La importacion los necesita completos para detectar duplicados y para generar codigos
 * consecutivos sin volver a consultar por fila. Se pagina con `noCache` para no trabajar
 * contra una copia vieja.
 */
export const drain = async <T>(api: Paginable<T>): Promise<T[]> => {
    const all: T[] = [];
    let token: string | undefined = undefined;

    do {
        const { items, nextToken } = await api.fetchAll({}, token, 1000, null, { noCache: true });
        all.push(...items);
        token = nextToken;
    } while (token);

    return all;
};
